import { motion } from "framer-motion";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Serve from "@/sections/Serve";
import Contact from "@/sections/Contact";
import Reveal from "@/components/Reveal";
import { HOME_TITLE, HOME_DESCRIPTION } from "@/lib/site";
import { usePageMeta } from "@/lib/seo";

const ITEMS = [
  "Wholesale Merchandise",
  "Overstock Goods",
  "Shelf Pulls",
  "Perishables",
  "Import / Export",
  "Global Sourcing",
];

const Marquee = () => (
  <div className="border-y border-slate-200 bg-white py-5 overflow-hidden" data-testid="category-marquee">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-mono text-[12px] md:text-[13px] tracking-[0.28em] uppercase text-slate-500 px-8">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-accent inline-block" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

const Home = () => {
  usePageMeta({ title: HOME_TITLE, description: HOME_DESCRIPTION });

  return (
    <main>
      <Hero />
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1, duration: 0.8 }}>
        <Marquee />
      </motion.div>
      <About />
      <Services />
      <Serve />
      <Reveal>
        <Contact />
      </Reveal>
    </main>
  );
};

export default Home;
